import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// CSS do legado + ponte --hi-* são injetados por `useLegadoVisual()` (login + /app),
// não aqui — /carreiras mantém `styles/carreiras.css` isolado.
import './index.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
